/* eslint-disable */
(function(algolia) {
  'use strict';

  const insightsClient = algolia.externals.insightsClient;

  window.addEventListener('algolia:productCard:quickAdd', (event) => {
    algolia.saveForConversionTracking(event.detail);
  })

  window.addEventListener('algolia:productCard:click', (event) => {
    trackClickEvent(event.detail);
  })

  function trackClickEvent (data) {
    // Send the click event to Algolia


    algolia.saveForConversionTracking(data);

    data.eventType = 'click'
    data.eventName = 'Item Selected'

    insightsClient('clickedObjectIDsAfterSearch', data)

  }

  function injectBanner(data, injectedNode) {
    const imgUrl = data.imagery_d.includes('?') ? `${data.imagery_d}&width=800` : `${data.imagery_d}?width=800`
    const fragment = `
      <a href="${data.link}">
        <picture style="display: block;">
          <source media="(min-width: 900px)" srcset="${imgUrl}" />
          <img class="ais-promo-banner_image" src="${imgUrl}" alt="${data.title}" />
        </picture>
      </a>
    `;

    const el = document.createElement('li')
    el.classList.add('ais-promo-banner', 'aa-Item')
    if (data.promo_size === "l") {
      el.classList.add('ais-promo-banner--large');
    }
    el.innerHTML = fragment

    if (!injectedNode.querySelector('.ais-promo-banner')) {
      injectedNode.insertAdjacentElement(
        'afterbegin',
        el
      );
    }

    const siblingCardImageHeight = injectedNode.querySelector('.aa-ItemPicture ').offsetHeight
    const promoBannerImage = injectedNode.querySelector('.ais-promo-banner').querySelector('picture')
    promoBannerImage.style.height = `${siblingCardImageHeight}px`
  }

  function removeBanner(injectedNode) {
    if(injectedNode?.querySelector('.ais-promo-banner') !== null) {
      injectedNode?.querySelector('.ais-promo-banner').remove()
    }
  }

  function bannerPlugin() {
    return {
      getSources({ query }) {
        return [
          {
            sourceId: 'banner',
            getItems() {
              return getAlgoliaResults({
                searchClient: algolia.searchClient,
                queries: [
                  {
                    indexName: algolia.config.index_prefix + 'products',
                    query,
                    params: {
                      ruleContexts: [algolia.config.customRuleContext],
                      hitsPerPage: 0,
                    },
                  },
                ],
                transformResponse({ results }) {
                  if(results.length === 0) return

                  const userData = results[0].userData || [];
                  if(userData.length === 0) {
                    // Remove banner from DOM if no rules are attached to the response
                    if(document.querySelector('[data-autocomplete-source-id="products"]')) {
                      removeBanner(document.querySelector('[data-autocomplete-source-id="products"]').querySelector('.aa-List'));
                    }
                  }

                  return userData;
                },
              });
            },
            templates: {
              item({ item }) {
                const fragmentInjectedNode = document.querySelector('[data-autocomplete-source-id="products"]').querySelector('.aa-List');

                if(item.link || fragmentInjectedNode) {
                  injectBanner(item, fragmentInjectedNode);
                }
              },
            },
          },
        ];
      },
    };
  }

  if (!algolia.config.autocomplete_enabled) return;

  const { autocomplete, getAlgoliaResults } = algolia.externals;

  algolia.searchClient.addAlgoliaAgent('Shopify Integration');

  // Retrieve the container from Shopify's config
  const containers = document.querySelectorAll(algolia.config.input_selector);
  containers.forEach((container) => {
    container.innerHTML = '';
    const containerClasses = container.classList;
    containerClasses.add('aa-MainContainer');
  })

  // Set plugins
  const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin, querySuggestionsPlugin, algoliaInsightsPlugin, recentSearchesPlugin } = algolia;
  const plugins = [
    algolia.config.analytics_enabled && algoliaInsightsPlugin,
    algolia.config.index_products && productsPlugin,
    algolia.config.index_collections && collectionsPlugin,
    algolia.config.index_articles && articlesPlugin,
    algolia.config.index_pages && pagesPlugin,
    algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin,
    recentSearchesPlugin,
    bannerPlugin()
  ];

  const cssFile = document.getElementById('template_algolia_autocomplete.css');

  // Set CSS variables
  document.documentElement.style.setProperty(`--aa-text-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
  document.documentElement.style.setProperty(`--aa-primary-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
  document.documentElement.style.setProperty(`--aa-muted-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
  document.documentElement.style.setProperty(`--aa-highlight-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);

  // Link CSS
  algolia.appendStyle(cssFile.text);

  const placeholder = (window.innerWidth > 900) ? `${window.theme.strings.algolia.form_placeholder}` : `${window.theme.strings.algolia.form_mobile_placeholder}`

  containers.forEach((container) => {
    autocomplete({
      container,
      openOnFocus: true,
      placeholder,
      debug: algolia.config.autocomplete_debug,
      plugins,
      render({ elements, render, html, state }, root) {
        const sourceIdsToExclude = ['products'];
        const hasLeftPanelResults = state.collections.filter(({source}) => sourceIdsToExclude.indexOf(source.sourceId) === -1).reduce((prev, curr) => prev + curr.items.length, 0) > 0;
        const [querySuggestionsPluginResults] = state.collections.filter(({source}) => source.sourceId === 'querySuggestionsPlugin');
        const displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0;
        render(hasLeftPanelResults ? algolia.mainTemplate({html, state}, elements, displaySuggestions) : algolia.mainProductsTemplate({html, state}, elements, displaySuggestions), root);
      },

      renderNoResults({render, html, state}, root) {
        if(state.status === 'idle') {
          render(algolia.noResultsTemplate({ html, state }), root);
        }
      },

      onSubmit({state, event}) {
        event.preventDefault();
        event.stopPropagation();
        document.querySelector('.aa-Input').focus()
        window.location.href = `/search?q=${state.query}`;
      },
      detachedMediaQuery: 'none'
    });
  })
})(window.algoliaShopify);
